import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { toast } from '../../hooks/use-toast';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ResetPassword = () => {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${BACKEND_URL}/api/admin/reset-password`, {
        token,
        password,
        passwordConfirm: confirm,
      });
      setDone(true);
      toast({ title: 'Mot de passe mis à jour', description: 'Vous pouvez maintenant vous connecter.' });
      setTimeout(() => navigate('/admin/login'), 1800);
    } catch (error) {
      toast({
        title: 'Échec de la réinitialisation',
        description: error.response?.data?.detail || 'Lien invalide ou expiré. Demandez un nouveau lien.',
        variant: 'destructive',
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-gray-900 rounded-lg p-8 shadow-2xl">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-600 rounded-full mx-auto mb-4 flex items-center justify-center">
              <span className="text-white font-bold text-2xl">NV</span>
            </div>
            <h1 className="text-2xl font-bold text-white mb-2">Nouveau mot de passe</h1>
            <p className="text-gray-400">PARTY-LED.COM</p>
          </div>

          {!token ? (
            <p className="text-center text-gray-400 text-sm py-6" data-testid="reset-missing-token">
              Lien incomplet. Rouvrez le lien reçu par email ou demandez-en un nouveau depuis la page de connexion.
            </p>
          ) : done ? (
            <p className="text-center text-green-400 text-sm py-6" data-testid="reset-success">
              Mot de passe mis à jour. Redirection vers la connexion…
            </p>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6" data-testid="reset-password-form">
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">Nouveau mot de passe (8 caractères minimum)</label>
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  minLength={8}
                  required
                  className="bg-gray-800 text-white border-gray-700"
                  data-testid="reset-password-input"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-300 mb-2">Confirmez le mot de passe</label>
                <Input
                  type="password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  placeholder="••••••••"
                  minLength={8}
                  required
                  className="bg-gray-800 text-white border-gray-700"
                  data-testid="reset-confirm-input"
                />
              </div>
              <Button
                type="submit"
                disabled={loading}
                className="w-full bg-gradient-to-r from-orange-500 to-red-600 hover:from-orange-600 hover:to-red-700 text-white py-3"
                data-testid="reset-submit-btn"
              >
                {loading ? 'Enregistrement…' : 'Enregistrer le nouveau mot de passe'}
              </Button>
            </form>
          )}

          <p className="text-center text-gray-500 text-sm mt-6">
            <button
              type="button"
              onClick={() => navigate('/admin/login')}
              className="text-orange-400 hover:text-orange-300 underline"
              data-testid="reset-back-to-login"
            >
              Retour à la connexion
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
